import React from 'react'
import { ButtonProps } from '@mui/material'
import * as S from './ButtonMui.styles'
import theme from 'src/styles/theme'

interface ButtonMuiProps extends Omit<ButtonProps, 'title'> {
    bgColor?: keyof typeof theme.colors;
    hoverColor?: keyof typeof theme.colors;
    letterColor?: keyof typeof theme.colors;
    disabledColor?: keyof typeof theme.colors;
    title: React.ReactNode;
    testId?: string;
}

const ButtonMui: React.FC<ButtonMuiProps> = ({
  bgColor, hoverColor, letterColor, disabledColor, testId, title, ...buttonProps
}) => (
  <S.Button
    data-testid={testId}
    $bgColor={buttonProps.disabled ? theme.colors.disabled : bgColor && theme.colors[bgColor]}
    $hoverColor={hoverColor && theme.colors[hoverColor]}
    $letterColor={letterColor && theme.colors[letterColor]}
    $disabledColor={disabledColor && theme.colors[disabledColor]}
    {...buttonProps}
  >
    {title}
  </S.Button>
)

export { ButtonMui }
